import 'css-chunksrc/client/scenes/calendar/displayToggle/styles.scss';export default {
  "input": "_input_6johp_1",
  "label": "_label_6johp_16",
  "chevron": "_chevron_6johp_23",
  "list": "_list_6johp_29",
  "options": "_options_6johp_37",
  "option": "_option_6johp_37",
  "selected": "_selected_6johp_53"
};